import { useMemo } from 'react';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import { useAssetCopierContext } from '../providers/AssetCopierProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SkippedAssetsAlert(props) {
  const {
    hideTitle
  } = props;
  const {
    skippedAssets
  } = useAssetCopierContext();
  const skippedCounts = useMemo(() => {
    const counts = {
      nonAutomatedEmails: 0,
      alreadyCopiedAssets: 0
    };
    skippedAssets.forEach(asset => {
      if (asset.skipReason === 'NOT_AUTOMATED_EMAIL') {
        counts.nonAutomatedEmails++;
      } else if (asset.skipReason === 'ALREADY_COPIED') {
        counts.alreadyCopiedAssets++;
      }
    });
    return counts;
  }, [skippedAssets]);
  if (skippedCounts.alreadyCopiedAssets === 0 && skippedCounts.nonAutomatedEmails === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIAlert, {
    titleText: !hideTitle && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ui-multi-account-asset-copier.panel.skippedAssetsAlert.title"
    }),
    className: "m-top-5",
    children: /*#__PURE__*/_jsxs(List, {
      styled: true,
      paddingInlineStart: "500",
      children: [skippedCounts.alreadyCopiedAssets > 0 && /*#__PURE__*/_jsx(ListItem, {
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-multi-account-asset-copier.panel.skippedAssetsAlert.alreadyCopiedAssets",
          options: {
            count: skippedCounts.alreadyCopiedAssets
          }
        })
      }), skippedCounts.nonAutomatedEmails > 0 && /*#__PURE__*/_jsx(ListItem, {
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-multi-account-asset-copier.panel.skippedAssetsAlert.nonAutomatedEmails",
          options: {
            count: skippedCounts.nonAutomatedEmails
          }
        })
      })]
    })
  });
}
export default SkippedAssetsAlert;